export default __webpack_public_path__ + "img/peach.92427fa0.svg";